module.exports = __webpack_public_path__ + "static/devops_success-19c3e513e1f09f79438144a2a6df3bd8.jpg";